import { render } from "./RealTimeAnalysis.vue?vue&type=template&id=45b6c56d&scoped=true"
import script from "./RealTimeAnalysis.vue?vue&type=script&lang=js"
export * from "./RealTimeAnalysis.vue?vue&type=script&lang=js"

import "./RealTimeAnalysis.vue?vue&type=style&index=0&id=45b6c56d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b6c56d"],['__file',"src/views/ProductDiagnosis/components/RealTimeAnalysis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45b6c56d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45b6c56d', __exports__)) {
    api.reload('45b6c56d', __exports__)
  }
  
  module.hot.accept("./RealTimeAnalysis.vue?vue&type=template&id=45b6c56d&scoped=true", () => {
    api.rerender('45b6c56d', render)
  })

}


export default __exports__